import { render, staticRenderFns } from "./ModifiedServiceName.vue?vue&type=template&id=2068bef0&"
import script from "./ModifiedServiceName.vue?vue&type=script&lang=js&"
export * from "./ModifiedServiceName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2068bef0')) {
      api.createRecord('2068bef0', component.options)
    } else {
      api.reload('2068bef0', component.options)
    }
    module.hot.accept("./ModifiedServiceName.vue?vue&type=template&id=2068bef0&", function () {
      api.rerender('2068bef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xZMY1aiN6FwV/JS/comp/ModifiedServiceName.vue"
export default component.exports